///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/task/EInvoice/mandatoryEInvoiceIconComponent"/>
import * as React from "react";
import { IconWithTooltip } from "@medius/ui-controls";
import IconDocumentEinvoiceRegular from "./iconDocumentEinvoiceRegular";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

const MandatoryEInvoiceIconComponent: React.FC = () => {
    return (
        <IconWithTooltip
            data-testid="mandatory-einvoice-tag"
            icon={<IconDocumentEinvoiceRegular color="info" />}
            text={translate("#Core/mandatoryEInvoice")}
            position="top"
        />
    );
};

export default MandatoryEInvoiceIconComponent;
